import pcURL from '@planningcenter/url';
import { useState, useEffect } from 'react';
import apiRequest, { defaultFetch } from '../../../../chat-core/api_request.js';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../../_virtual/moment.js';
import { useChat } from '../../../hooks/use_chat.js';
import '../../../chat_api_context.js';
import '@planningcenter/jolt-client';
import 'stream-chat';

function useNewGroupChatPeople(groupId) {
    const { currentPersonId, env } = useChat();
    const url = `${pcURL(env)("api")}/groups/v2/me/groups/${groupId}/memberships`;
    const params = new URLSearchParams({
        "fields[Membership]": "person,role",
        "fields[Person]": "avatar_url,child,first_name,last_name",
        include: "person",
        per_page: "50",
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [people, setPeople] = useState([]);
    const [totalCount, setTotalCount] = useState(null);
    const hasMore = totalCount === null ? null : totalCount > people.length;
    const loadMembers = () => {
        setIsLoading(true);
        apiRequest(defaultFetch, `${url}?${params}`)
            .then(({ json }) => {
            const results = json.data.map((result) => {
                const person = json.included.find((i) => i.type === "Person" &&
                    i.id === result.relationships.person.data.id);
                const badges = [];
                if (result.attributes.role === "leader") {
                    badges.push({ title: "Leader" });
                }
                if (person.id === currentPersonId) {
                    badges.push({ title: "Conversation owner" });
                }
                return {
                    avatar: person.attributes.avatar_url,
                    badges: badges,
                    child: person.attributes.child,
                    id: person.id,
                    name: `${person.attributes.first_name} ${person.attributes.last_name}`,
                    source: [],
                };
            });
            setPeople((prev) => [...prev, ...results]);
            setTotalCount(json.meta.total_count);
        })
            .catch(() => setIsError(true))
            .finally(() => setIsLoading(false));
    };
    useEffect(() => {
        loadMembers();
    }, []);
    return { hasMore, isError, isLoading, people, totalCount };
}

export { useNewGroupChatPeople };
//# sourceMappingURL=use_new_group_chat_people.js.map
